import moment from 'moment'

const initialState = {
  date: moment().toDate(),
  todos: []
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_CALENDAR_TODOS':
      return {
        ...state,
        todos:  action.payload
      }
    case 'SET_DATE':
      return {
        ...state,
        date:  action.date
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/calendar.js